import CollectionAddPostPopup from "./collection-add-post-popup";

export default CollectionAddPostPopup;